import request from "@/utils/request.js";
class Api {
  // 添加菜单
  menuAdd(data) {
    return request({
      method: "post",
      url: "/menu/add",
      data,
    });
  }
  // 菜单列表
  menuList() {
    return request({
      method: "get",
      url: "/menu/list",
    });
  }
  //   编辑菜单
  menuEdit(data) {
    return request({
      method: "post",
      url: "/menu/edit",
      data,
    });
  }
  //   删除菜单
  menuDel(data) {
    return request({
      method: "post",
      url: "/menu/del",
      data,
    });
  }
}
export default new Api();
